import { Component, OnDestroy, OnInit } from "@angular/core";
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { ILead } from "./types/lead";
import { ActivatedRoute } from "@angular/router";
import { DbLeadsProvider } from "../providers/database/db-leads";
import { Subscription } from "rxjs";

@Component({
    selector: 'app-leads-dashboard',
    templateUrl: './leads-dashboard.component.html',
    styleUrls: ['./leads-dashboard.component.scss']
})
export class LeadsDashboardComponent implements OnInit, OnDestroy {
    subscriptions: Subscription[] = [];
    isLoading: boolean = true;
    eventId: string = "";
    userId: string = "";
    query: string = "";
    showLeadsType: "all" | "email" | "phone" = "all";
    leadsSort: "asc" | "desc" = "asc";
    leads: ILead[] = []
    leadsFiltered: ILead[] = [];
    leadsExport: any[] = [];

    constructor(
        private route: ActivatedRoute,
        private dbLeads: DbLeadsProvider,
    ) { }

    ngOnInit(): void {
        this.eventId = this.route.snapshot.params['eventId'];
        this.userId = this.route.snapshot.params['userId'];
        this.fetchLeads();
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach((subscription) =>
            subscription.unsubscribe()
        );
    }

    fetchLeads() {
        const subscription = this.dbLeads
            .fetchLeads(this.eventId, this.userId)
            .subscribe((leads) => {
                this.leads = leads;
                this.handleFilterLeads();
                this.isLoading = false;
            });

        this.subscriptions.push(subscription);
    }

    handleLeadsSort() {
        this.leads = this.leads.sort((a, b) => {
            if (this.leadsSort === "asc") {
                return a.name.localeCompare(b.name);
            } else {
                return b.name.localeCompare(a.name);
            }
        });
        this.handleFilterLeads();
    }

    handleFilterLeads() {
        if (this.showLeadsType === "all") {
            this.leadsFiltered = this.query
                ? this.leads.filter((lead) => {
                      return lead.name
                          .toLowerCase()
                          .includes(this.query.toLowerCase());
                  })
                : this.leads;
        } else {
            this.leadsFiltered = this.leads.filter(lead => {
                if (this.showLeadsType === "email") {
                    return this.query
                        ? lead.name
                              .toLowerCase()
                              .includes(this.query.toLowerCase()) && lead.email
                        : lead.email;
                } else if (this.showLeadsType === "phone") {
                    return this.query
                        ? lead.name
                              .toLowerCase()
                              .includes(this.query.toLowerCase()) && lead.phone
                        : lead.phone;
                }
            });
        }
    }

    exportLeads() {
        if (this.leads.length === 0) return;
        this.leadsExport = [];
        this.leadsExport = [[
            "name",
            "email",
            "phone",
            "website",
            "evaluation",
            "notes",
            "socialMediaLinks"
        ]];
        for (let i = 0; i < this.leads.length; i++) {
          const row = this.instantiateLeadRow(this.leads[i]);
          this.leadsExport.push(row);
        }

        const wscols: XLSX.ColInfo[] = [
            { wpx: 150 }, // "pixels"
            { wpx: 200 }, // "pixels"
            { wpx: 150 }, // "pixels"
            { wpx: 200 }, // "pixels"
            { wpx: 150 }, // "pixels"
            { wpx: 150 }, // "pixels"
            { wpx: 250 }, // "pixels"
        ];

        /* At 96 PPI, 1 pt = 1 px */
        const wsrows: XLSX.RowInfo[] = [
            { hpx: 25 }, // "pixels"
        ];

        /* generate worksheet */
        const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(this.leadsExport);

        /* TEST: column props */
        ws['!cols'] = wscols;

        /* TEST: row props */
        ws['!rows'] = wsrows;

        /* generate workbook and add the worksheet */
        const wb: XLSX.WorkBook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

        /* save to file */
        const wbout: string = XLSX.write(wb, { bookType: 'xlsx', type: 'binary' });
        saveAs(new Blob([this.s2ab(wbout)]), 'leads.xlsx');
    }

    // AJUDA A GERAR O ARQUIVO EXCEL
    private s2ab(s: string): ArrayBuffer {
        const buf: ArrayBuffer = new ArrayBuffer(s.length);
        const view: Uint8Array = new Uint8Array(buf);
        for (let i = 0; i !== s.length; ++i) {
          view[i] = s.charCodeAt(i) & 0xFF;
        }
        return buf;
    }

    instantiateLeadRow(lead: ILead) {
        const row = [];
        row.push(lead.name);
        row.push(lead.email);
        row.push(lead?.phone ?? "");
        row.push(lead?.website ?? "");
        row.push(lead?.evaluation ?? "");
        row.push(lead?.notes ?? "");
        row.push(lead?.socialMediaLinks?.join("\n") ?? "");

        return row;
    }
}
